import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import DatePicker from 'components/sales/datePicker/datePicker';
import DropDownInput from '../Input/dropDownInput/dropDownInput';

const RateMeetingFilter = ({
  applyFilter,
  emailDropdownFilter,
  type,
  userFilter
}) => {
  const parseLocalStorage = () => {
    try {
      const data = JSON.parse(window.localStorage?.filterDataIncentive || '{}');
      return {
        user_name: data.user_name || '',
        from_date: data.from_date || '',
        to_date: data.to_date || '',
        month: data.month || ''
      };
    } catch {
      return {
        user_name: '',
        from_date: '',
        to_date: '',
        month: ''
      };
    }
  };

  const initialFilterInputs = parseLocalStorage();

  const [filterFieldsData, setFilterFieldsData] = useState({
    user_name: initialFilterInputs.user_name,
    from_date: initialFilterInputs.from_date,
    to_date: initialFilterInputs.to_date,
    month: initialFilterInputs.month || ''
  });

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
      user_name: storedData.user_name ?? '',
      from_date: storedData.from_date ? formatDate(storedData.from_date) : '',
      to_date: storedData.to_date ? formatDate(storedData.to_date) : '',
      month: storedData.month ?? ''
    });
  }, []);

  console.log("TYPE CHECK:", type);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
          user_name: filterFieldsData.user_name ?? '',
          to_date: filterFieldsData.to_date ? formatDate(filterFieldsData.to_date) : '',
          from_date: filterFieldsData.from_date ? formatDate(filterFieldsData.from_date) : '',
          month: filterFieldsData.month?? ''
        });
      }}
    >
    { userFilter === true  && (
          <DropDownInput
          label="User Name"
              data={emailDropdownFilter}
          getIdValue={(val) => {
              setFilterFieldsData({
              ...filterFieldsData,
              user_name: val.id,
              });
          }}
      />
    )}  

    {type === "HOD" && (
        <DropDownInput
            data={[
                { id: 1, name: 'January' },
                { id: 2, name: 'February' },
                { id: 3, name: 'March' },
                { id: 4, name: 'April' },
                { id: 5, name: 'May' },
                { id: 6, name: 'June' },
                { id: 7, name: 'July' },
                { id: 8, name: 'August' },
                { id: 9, name: 'September' },
                { id: 10, name: 'October' },
                { id: 11, name: 'November' },
                { id: 12, name: 'December' }            
            ]}
            label={'Month'}
            getIdValue={(val) => {
                setFilterFieldsData({
                ...filterFieldsData,
                month: val.id,
            });
            }}
            value={window.localStorage?.ratingFilter && window.localStorage?.ratingFilter ? JSON.parse(window.localStorage?.ratingFilter)['month'] : ""}
        />
    )}
    {type === "SENIOR" && (
    <>
        <DatePicker
        handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, from_date: val })
        }
        label="From Date"
        required={false}
        value={window.localStorage?.ratingFilter && window.localStorage?.ratingFilter ? JSON.parse(window.localStorage?.ratingFilter)['from_date'] : ""}
        />
        <DatePicker
        handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, to_date: val })
        }
        label="To Date"
        required={false}
        value={window.localStorage?.ratingFilter && window.localStorage?.ratingFilter ? JSON.parse(window.localStorage?.ratingFilter)['to_date'] : ""}
        />
    </>
    )}
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(initialFilterInputs);
            applyFilter({
              user_name: '',
              to_date: '',
              from_date: ''
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default RateMeetingFilter;
